import { Star, Quote } from "lucide-react";
import { Reveal } from "../Reveal";
import { TESTIMONIALS } from "../../data/content";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative bg-[#f3f2ee] py-24 lg:py-36"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <Reveal>
            <span className="text-[#e85d04] text-xs font-bold tracking-[0.28em] uppercase">
              Testimonials
            </span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display font-bold text-[#131316] text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4">
              Trusted on the water.
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.12}>
              <div
                data-testid={`testimonial-card-${i}`}
                className="h-full bg-white rounded-3xl p-8 border border-black/5 shadow-sm hover:shadow-xl transition-shadow duration-500 flex flex-col"
              >
                <div className="flex items-center justify-between mb-5">
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} size={18} className="fill-[#e85d04] text-[#e85d04]" />
                    ))}
                  </div>
                  <Quote size={28} className="text-black/10" />
                </div>
                <p className="text-[#131316]/75 text-base leading-relaxed flex-1">
                  "{t.text}"
                </p>
                <div className="mt-6 pt-6 border-t border-black/5 flex items-center gap-3">
                  <div className="h-11 w-11 rounded-full bg-[#131316] text-white font-display font-bold flex items-center justify-center">
                    {t.name.charAt(0)}
                  </div>
                  <div>
                    <p className="font-display font-semibold text-[#131316]">{t.name}</p>
                    <p className="text-sm text-[#131316]/50">{t.role}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
